import { useState } from "react";
import Person from "../../model/person";
import { setPersonState } from "../providers/person";

export function usePerson(name: string, country?: string, countryAcronym?: string): [Person, Function] {
    const [state, setState] = useState({
        name: name,
        country: country || "",
        countryAcronym: countryAcronym || "",
    });

    return [state, (stateVar: string, name: string) => setPersonState(setState, stateVar, name)];
}
